import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MediaViewerComponent } from '../media-viewer/media-viewer.component';
import { IArchivo } from '../../../../model/interface/IArchivo';

import * as _ from 'lodash';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit {

  items: IArchivo[];
  itemsMostrados: IArchivo[];
  constVideos = ['CAT_ESP_VIDEO_GALERIA', 'PROD_VIDEO_GALERIA'];
  tipoMostrado = 'fotos-videos';

  groupMovil: any[] = [];
  slideConfig = {'slidesToShow': 1, 'slidesToScroll': 1, 'arrows': false, 'dots': true};

  @Input() titulo: string;
  @Input()
  set itemsGallery(itemsGallery: any[]) {

    _.each(itemsGallery, (o) => {
      if (this.isVideo(o)) {
        o.previewUrl = o.url + '?rel=0&amp;controls=0&amp;showinfo=0';
        o.esVideo = true;
      } else {
        o.esVideo = false;
      }
    });

    this.items = itemsGallery;
    this.filtrarArchivos();

    /**
     * Agrupado para Movil
     */
    const total = Math.ceil(this.items.length / 4);
    for (let i = 0; i < total; i++) {
      this.groupMovil.push(_.slice(this.items, (i * 4), ((i + 1) * 4)));

    }
  }

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit() {
  }

  viewContet(index: number) {
    const viewModal = this.modalService.open(MediaViewerComponent,  {size: 'lg', windowClass: 'media-viewer'});
    viewModal.componentInstance.items = this.items;
    viewModal.componentInstance.currentItem = index;
  }


  filtrarArchivos() {

    switch (this.tipoMostrado) {
      case 'fotos-videos':
        this.itemsMostrados = this.items;
        break;
      case  'fotos':
        this.itemsMostrados = _.filter(this.items, {'esVideo': false});
        break;
      case 'videos':
        this.itemsMostrados = _.filter(this.items, {'esVideo': true});
    }

  }

  isVideo (archivo: IArchivo) {
    if (this.constVideos.indexOf(archivo.tipo) >= 0) {
      return true;
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/utils/gallery/gallery.component.ts